const route = [
    //修改姓名
    {
        path: '/mine/:type',
        component: function (resolve) {
            require(['VIEWS/mine/edit.vue'], resolve);
        },
    },

];
export default route
